import metaInfo from "./meta";
const Breadcrumbs = () =>
	import(
		/* webpackChunkName: "component-breadcrumbs" */ "@/components/breadcrumbs"
	);
const Advertising = () =>
	import(
		/* webpackChunkName: "component-advertising" */ "@/components/advertising"
	);
import { dateAsObject, currentDateAsObject } from "@/common/functions";
import { AD_LAYOUT_STUBS } from "@/common/consts";
const LoadingSpinner = () =>
	import(
		/* webpackChunkName: "component-loading-spinner" */ "@/components/loading-spinner"
	);
const DailyPuzzleCard = () =>
	import(
		/* webpackChunkName: "component-daily-puzzle-card" */ "@/components/daily-puzzle-card"
	);
const Pagination = () =>
	import(
		/* webpackChunkName: "component-pagination" */ "@/components/pagination"
	);
import { mapGetters, mapState } from "vuex";

const ONE_DAY_IN_MS = 86400000;
const PUZZLES_PER_PAGE = 30;
const OLDEST_DAILY_PUZZLE_DATE = new Date("01/01/2019");
const MIN_PAGE_NUMBER = 1;

export default {
	name: "DailyPuzzlePage",
	data() {
		return {
			AD_LAYOUT_STUBS,
			isLoading: false,
		};
	},
	components: {
		Advertising,
		Breadcrumbs,
		DailyPuzzleCard,
		LoadingSpinner,
		Pagination,
	},
	methods: {
		isPresentDay(date) {
			const presentDay = currentDateAsObject();
			return (
				presentDay.day === date.day &&
				presentDay.month === date.month &&
				presentDay.year === date.year
			);
		},
		isLaterThanOldestDailyPuzzle(date) {
			return OLDEST_DAILY_PUZZLE_DATE < date;
		},
		loadDailyPuzzlesList(currentPage) {
			this.isLoading = true;
			let puzzleDate = new Date(
				new Date() - 30 * (currentPage - 1) * ONE_DAY_IN_MS
			);
			let puzzlesList = [];

			while (
				this.isLaterThanOldestDailyPuzzle(puzzleDate) &&
				puzzlesList.length < PUZZLES_PER_PAGE
			) {
				puzzlesList.push(dateAsObject(puzzleDate));
				puzzleDate = new Date(Date.parse(puzzleDate) - ONE_DAY_IN_MS);
			}
			this.$store.commit("setDailyPuzzleList", puzzlesList);

			this.isLoading = false;
		},
		changePageCallback(newPage) {
			if (newPage < MIN_PAGE_NUMBER) {
				newPage = 1;
			} else if (newPage > this.maxPage) {
				newPage = this.maxPage;
			}
			this.$store.commit("setDailyPuzzleCurrentPage", newPage);
			this.loadDailyPuzzlesList(newPage);
		},
		setMaxPageNumber() {
			const differenceInMs = Math.abs(
				new Date() - OLDEST_DAILY_PUZZLE_DATE
			);

			this.$store.commit(
				"setDailyPuzzleMaxPage",
				Math.ceil(differenceInMs / (ONE_DAY_IN_MS * PUZZLES_PER_PAGE))
			);
		},
	},
	computed: {
		...mapGetters(["topElementsHeight"]),
		...mapState({
			dailyPuzzlesList: (state) => state.dailyPuzzles.dailyPuzzlesList,
			currentPage: (state) => state.dailyPuzzles.currentPage,
			maxPage: (state) => state.dailyPuzzles.maxPage,
		}),
		breadcrumb() {
			return [
				{
					label: this.$t("BreadcrumbWordscapesDailyIndexPageText"),
				},
			];
		},
	},
	mounted: function() {
		this.setMaxPageNumber();
		this.loadDailyPuzzlesList(this.currentPage);
	},
	metaInfo,
};
